var _rect, _g, _g2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLibraryEsops(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 394,
    height: 245,
    viewBox: "0 0 394 245",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4130_7728)"
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 393.333,
    height: 245,
    fill: "#FFFAEB"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_i_4130_7728)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_i_4130_7728)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 197,
    cy: 122,
    r: 56,
    fill: "url(#paint0_linear_4130_7728)",
    fillOpacity: 0.08
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 197,
    cy: 122,
    r: 62,
    stroke: "white",
    strokeWidth: 12
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_i_4130_7728)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M201 120H189M193 128H189M205 112H189M213 111.6V132.4C213 135.76 213 137.44 212.346 138.724C211.771 139.853 210.853 140.771 209.724 141.346C208.44 142 206.76 142 203.4 142H190.6C187.24 142 185.56 142 184.276 141.346C183.147 140.771 182.229 139.853 181.654 138.724C181 137.44 181 135.76 181 132.4V111.6C181 108.24 181 106.56 181.654 105.276C182.229 104.147 183.147 103.229 184.276 102.654C185.56 102 187.24 102 190.6 102H203.4C206.76 102 208.44 102 209.724 102.654C210.853 103.229 211.771 104.147 212.346 105.276C213 106.56 213 108.24 213 111.6Z",
    stroke: "url(#paint1_linear_4130_7728)",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))), /*#__PURE__*/React.createElement("foreignObject", {
    x: 5,
    y: -70,
    width: 383,
    height: 383
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      backdropFilter: "blur(10px)",
      clipPath: "url(#bgblur_1_4130_7728_clip_path)",
      height: "100%",
      width: "100%"
    }
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_d_4130_7728)",
    "data-figma-bg-blur-radius": 20
  }, /*#__PURE__*/React.createElement("path", {
    d: "M196.5 293C291.217 293 368 216.217 368 121.5C368 26.7832 291.217 -50 196.5 -50C101.783 -50 25 26.7832 25 121.5C25 216.217 101.783 293 196.5 293ZM196.5 30.1938C246.927 30.1938 287.806 71.073 287.806 121.5C287.806 171.927 246.927 212.806 196.5 212.806C146.073 212.806 105.194 171.927 105.194 121.5C105.194 71.073 146.073 30.1938 196.5 30.1938Z",
    fill: "white",
    fillOpacity: 0.6,
    shapeRendering: "crispEdges"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_4130_7728",
    x: 129,
    y: 54,
    width: 136,
    height: 136,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.711529 0 0 0 0 0.279671 0 0 0 0 0.0296471 0 0 0 0.19 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_4130_7728"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_i_4130_7728",
    x: 129,
    y: 54,
    width: 136,
    height: 136,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 16
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.711529 0 0 0 0 0.279671 0 0 0 0 0.0296471 0 0 0 0.35 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_4130_7728"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_i_4130_7728",
    x: 179,
    y: 100,
    width: 36,
    height: 45.2,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.6
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.18 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_4130_7728"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_d_4130_7728",
    x: 5,
    y: -70,
    width: 383,
    height: 383,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.02 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_4130_7728"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_4130_7728",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "bgblur_1_4130_7728_clip_path",
    transform: "translate(-5 70)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M196.5 293C291.217 293 368 216.217 368 121.5C368 26.7832 291.217 -50 196.5 -50C101.783 -50 25 26.7832 25 121.5C25 216.217 101.783 293 196.5 293ZM196.5 30.1938C246.927 30.1938 287.806 71.073 287.806 121.5C287.806 171.927 246.927 212.806 196.5 212.806C146.073 212.806 105.194 171.927 105.194 121.5C105.194 71.073 146.073 30.1938 196.5 30.1938Z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4130_7728",
    x1: 197,
    y1: 66,
    x2: 197,
    y2: 178,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDB022"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B54708"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_4130_7728",
    x1: 180.333,
    y1: 112.833,
    x2: 219.447,
    y2: 144.45,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F79009"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B54708"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4130_7728"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 393.333,
    height: 245,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLibraryEsops);
export default __webpack_public_path__ + "static/media/library-esops.ea97d6694c8d99821eb7ab5742efc714.svg";
export { ForwardRef as ReactComponent };